import i18n from '@/lang/lang'
import router from '@/router'
// const debug = require('debug')('OD::Lib:MetaHelper')

function fullImage(club) {
  if (club) {
    if (club.poster) {
      return club.poster
    }
    return `https://${i18n.t('site.url')}/img/sports/${club.sport}.jpg`
  }
  return ''
}

function url(config) {
  const href = router.resolve(config).href
  const host = `https://${i18n.t('site.url')}`
  return host + href
}

function generateMeta({ appName, appDescription, title, description, url, image }) {
  return [
    { name: 'application-name', content: appName },
    { name: 'description', content: description, id: 'desc' },
    { property: 'fb:app_id', content: i18n.t('site.facebook.appId') },
    { property: 'og:url', content: url },
    { property: 'og:type', content: 'article' },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:image', content: image },
    { property: 'twitter:card', content: 'summary' },
    { property: 'twitter:site', content: i18n.t('site.twitter.account') },
    { property: 'twitter:title', content: title },
    { property: 'twitter:description', content: description },
    { property: 'twitter:image', content: image },
  ]
}

export default {
  getTitle(page) {
    const title = { inner: i18n.t(`page.${page}.title`) }
    return title
  },
  getMeta(page, to) {
    const meta = generateMeta({
      appName: i18n.t('site.title'),
      appDescription: i18n.t('site.description'),
      title: i18n.t(`page.${page}.title`),
      description: i18n.t('site.description'),
      url: url(to),
      image: '',
    })
    return meta
  },
  getClubTitle(clubId, club, page) {
    const clubName = club && club.club ? club.club : ''
    let inner = clubName ? `${clubName} | ` : ''
    inner += i18n.t(`page.club.${page}.title`)
    return { inner }
  },
  getClubMeta(clubId, club, page, navigation) {
    const clubName = club && club.club ? club.club : ''
    const clubDescription = club && club.description ? club.description : ''
    let title = clubName ? `${clubName} | ` : ''
    title += i18n.t(`page.club.${page}.title`)
    const meta = generateMeta({
      appName: i18n.t('site.title'),
      appDescription: i18n.t('site.description'),
      title,
      description: clubDescription,
      url: url(navigation),
      image: fullImage(club),
    })
    return meta
  },
}
